/// <reference types="vite/client" />

interface AppConfig {
  supabase: {
    url: string;
    anonKey: string;
    serviceRoleKey: string;
  };
  app: {
    name: string;
    version: string;
    environment: 'development' | 'staging' | 'production';
    buildTime: string;
  };
  features: {
    enableNotifications: boolean;
    enableReports: boolean;
    enableAdvancedScheduling: boolean;
  };
  business: {
    defaultTaxRate: number;
    workingHours: {
      start: string;
      end: string;
    };
    defaultJobDuration: number;
  };
}

export const getAppConfig = (): AppConfig => {
  // Support both Next.js (process.env) and Vite (import.meta.env) environments
  const env: Record<string, string | undefined> = typeof process === 'undefined' ? {} : process.env;
  const viteEnv: Record<string, string | undefined> = typeof import.meta !== 'undefined' ? import.meta.env : {};
  
  return {
    supabase: {
      url: (env.NEXT_PUBLIC_SUPABASE_URL || viteEnv.VITE_SUPABASE_URL) as string,
      anonKey: (env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY || viteEnv.VITE_SUPABASE_PUBLISHABLE_KEY) as string,
      serviceRoleKey: (env.NEXT_PUBLIC_SUPABASE_SERVICE_ROLE_KEY || viteEnv.VITE_SUPABASE_SERVICE_ROLE_KEY) as string,
    },
    app: {
      name: 'Go Sit Back',
      version: (env.NEXT_PUBLIC_BUILD_TIME || viteEnv.VITE_BUILD_TIME) || new Date().toISOString(),
      environment: ((env.NEXT_PUBLIC_ENVIRONMENT || viteEnv.VITE_ENVIRONMENT) as 'development' | 'staging' | 'production') || 'development',
      buildTime: (env.NEXT_PUBLIC_BUILD_TIME || viteEnv.VITE_BUILD_TIME) || new Date().toISOString(),
    },
    features: {
      enableNotifications: (env.NEXT_PUBLIC_ENABLE_NOTIFICATIONS || viteEnv.VITE_ENABLE_NOTIFICATIONS) === 'true',
      enableReports: (env.NEXT_PUBLIC_ENABLE_REPORTS || viteEnv.VITE_ENABLE_REPORTS) === 'true',
      enableAdvancedScheduling: (env.NEXT_PUBLIC_ENABLE_ADVANCED_SCHEDULING || viteEnv.VITE_ENABLE_ADVANCED_SCHEDULING) === 'true',
    },
    business: {
      defaultTaxRate: Number.parseFloat(env.NEXT_PUBLIC_DEFAULT_TAX_RATE || viteEnv.VITE_DEFAULT_TAX_RATE || '8.5'),
      workingHours: {
        start: (env.NEXT_PUBLIC_WORKING_HOURS_START || viteEnv.VITE_WORKING_HOURS_START) || '08:00',
        end: (env.NEXT_PUBLIC_WORKING_HOURS_END || viteEnv.VITE_WORKING_HOURS_END) || '18:00',
      },
      defaultJobDuration: Number.parseInt(env.NEXT_PUBLIC_DEFAULT_BOOKING_DURATION || viteEnv.VITE_DEFAULT_BOOKING_DURATION || '120'),
    },
  };
};
